import { useEffect, useRef } from "react";
import { getAuthRedirectPath } from "@/utils/navigation";
import { useCallbackRef } from "./useCallbackRef";
import { canAutofillPasskeys } from "@/utils/passkeys";
import { signInWithPasskey } from "@/api/authNew";
import { useRouter } from "@/i18n/routing";
import { useLocale } from "next-intl";
import { useQueryClient } from "@tanstack/react-query";

export const usePreloadPasskeys = () => {
  const locale = useLocale();
  const router = useRouter();
  const started = useRef(false);
  const queryClient = useQueryClient();

  const signIn = useCallbackRef(async () => {
    const available = await canAutofillPasskeys();
    if (!available) {
      return;
    }

    try {
      queryClient.clear();
      const auth = await signInWithPasskey({ autoFill: true });
      const entryPath = getAuthRedirectPath(auth);
      router.replace(entryPath, { locale });
      router.refresh();
    } catch {}
  });

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    signIn();
  }, []);
};
